export default {
    newsDetailTitle: "Revealed: the three most deadly pain points of risk control of Internet finance in Southeast Asia",
    newsDetailTime: "pubdate",
    newsDetailRead: "Pageviews",
    newsDetailSource:"Article source:",
    newsDetail: [{
            p: ' It is not that "risk control outsourcing" cannot be trusted, but the cost of such trust is simply too high. ',
        },
        {
            p: ' With data or without data?'
        },
        {
            p: ' Just after the last interview with a Singapore-based enterprise that provides credit investigation service by using "metadata", the interviewed enterprise hoped to recommend several Indonesian cash loan enterprises that can be connected with it. With a view to promoting the healthy development of Indonesia’s fintech market, we recommend several companies with such needs, ranging from six-month cash instalments to 7-day and 14-day cash loans.',
        },
        {
            p: "The data firm's service features a customised user credit rating for different financial products, which captures only the user's device habits, a model that is promising in regions without national credit data centres.",
        },
        {
            p: 'The data is desensitized, the team is reliable, the market is compatible, and it solves the problem that many people have raised about the lack of credit data in Southeast Asia (after all, whenever a user uses a smartphone, the metadata used for rating is generated). You can see good incentives for collaboration.',
        },
        {
            p: 'The only thing that is unacceptable is that these companies need to plug into the SDK of the cash lending company to collect data for early testing. This is where intentions diverge.',
        },
        {
            p: ' For cash lenders still exploring the local market, the sample data they have obtained may be more important than anything else, because more regular customers means higher loan rates, which in turn means lower acquisition and risk control (anti-fraud) costs, as well as better bad-debt rates.',
        },
        {
            h4: ' This story might make sense to the local team, but in the eyes of Chinese cash lenders, it might be considered a smoke screen.',
        },
        {
            p: 'Why is that?',
        },
        {
            p: 'Some of Indonesia’s local mutual-finance practitioners, who are more financial minded than Internet minded, want to have a credit database ready to use, like a child who has been ‘raised by the rich’. A small number of data to choose stability, may miss the opportunity.',
        },
        {
            p: 'However, the "wild children" with strong Internet thinking in China do not accept their fate. The popularization speed of mobile Internet in Indonesia is so fast that it is completely unfounded without data. Just how to collect this data, and how to evaluate the data is not too mature, but it is man-made, and promising.',
        },
        {
            h4: 'None of the three links is short',
        },
        {
            p: 'Therefore, cash lenders in the Chinese team are more inclined to cooperate with the third party with credit data, rather than doing analysis on their platform. Such SaaS service is quite marketable, because few Indonesian cash loan companies are complete in "data + sample + risk control ability", which almost represent whether a cash loan can grow in a high long-term.',
        },
        {
            p: '(1) Data means that there are quantifiable reference characteristic variables.',
        },
        {
            p: 'In terms of data, local enterprises have an advantage, after all, it is more smooth when discussing cooperation with other local industry institutions or platforms.  (Of course, crawler is a method, but the quality of data crawler is difficult to guarantee, and may not be able to climb);',
        },
        {
            p: '(2) Sample means that rules or models can be evaluated and optimized.',
        },
        {
            p: 'Only big players have the chance to accumulate enough samples. In the early stage, who can pay more for quantity or find a more efficient way to accumulate samples can make a breakthrough in the effect evaluation of the model.',
        },
        {
            p: ' (3) Risk control ability means that corresponding technical talents are required.',
        },
        {
            p: "On this point, in fact, the Chinese team has a great advantage. It is also the power of China in Indonesia's cash loan that I mentioned in the article written before."
        },
        {
            p: "At the moment, there are few platforms for all three."
        },
        {
            p: "What can be done about the pain of risk control?"
        },
        {
            p: "First, the introduction of risk control modeling capabilities by local giants"
        },
        {
            p: "Big companies are in the best position to solve this problem. It's just a matter of time and money. Already got the compliance registration of a few are now in practice 'risk control law', often walk in the river, which is not wet shoes? With samples and data in hand, the long-term solution is to improve risk control ability as soon as possible. At present, there is an acute shortage of risk control talents in Indonesia, so you can pay attention to the 'fat jo' of Southeast Asia Mutual Capital."
        },
        {
            p: "Second, overseas enterprises are more likely to cooperate with local companies with data scenarios"
        },
        {
            p: "What about samples of phones from your platform without data? The solution is to fight the father or the relationship. Data privacy in Southeast Asia is only getting stricter. What is the starting point for the big platforms to share data? Find a breakthrough and it may well be South-East Asia's 'fun shop', if only for the growth period."
        },
        {
            h4: "What does this look like in Financial Services?"
        },
        {
            p: "Financial services industry, where applications manage very sensitive data, is naturally a great industry target for Federated Learning. Loan Risk Prediction is one specific example — below, we will see how to get a basic Federated Learning application up and running. Doing so, we’ll be able to see the benefits of using PySyft to create private AI."
        },
        {
            p: "Let’s recap the workflow enabled via Federated Learning and PySyft:"
        },
        {
            p: "1、Data Scientists develop deep learning architecture in PyTorch"
        },
        {
            p: "2、PySyft encrypts model and sends model to the data owner"
        },
        {
            p: "3、Model is trained on data owner’s premises, with data scientist specifying training parameters (like learning rate or number of iterations)"
        },
        {
            p: "4、Updated model(s) are sent from data owner back to data scientist"
        },
        {
            p: "5、In the case of multiple data owners, each model which was trained on a subset of the total iterations is averaged with the other models "
        },
        {
            p: "6、Rinse and repeat for desired number of training iterations!"
        },
        {
            p: "Now that a model has been trained, the process to get predictions to the data owner is very simple. This process is again facilitated by PySyft."
        },
        {
            p: "1、Send model to data owner via PySyft’s encryption."
        },
        {
            p: "2、Model runs on client data, only feeding forward through the neural net, and returns predictions to the data owner"
        },
        {
            p: "Now, let’s go in depth to see the essential steps of building a sample application using Federated Learning."
        },
        {
            p: "To initialize PySyft and ensure all deep learning operations are made secure, PySyft is “hooked” to the PyTorch library."
        },
        {
            p: "On the data owner’s end, the data now needs to be deployed via a WebsocketServerWorker, which enables federated learning. Different arguments are specified, such as host IP, the PySyft hook, and the specific port that Finastra’s PySyft client will connect to."
        },
        {
            p: "Now that a dataset is deployed from the Data Owner, we data scientists can connect via a WebsocketClientWorker defined in the PySyft library."
        },
        {
            p: "Next, we can specify the model and its training configuration. These will be sent to each WebsocketServerWorker (in this case there’s only one). Since PySyft sits on top of PyTorch, these are defined via Torch syntax."
        },
        {
            p: "Now, the function fit_model_on_worker handles several steps. Via Syft, the model and training configuration is encrypted, the model is trained securely on the data owner, and lastly the updated model and its training loss are retrieved. All that needs to happen now is to call the function on each of the Data Owners. Although the computation is happening on the Data Owner side, all of the training is initiated by the data scientist!"
        },
        {
            p: "Now, we have obtained potentially several models from each remote worker. All that remains is to combine all the models into a final model via averaging all weights and parameters together. Naturally, this is also handled by PySyft."
        },
        {
            p: "After running the training and averaging loop for the desired number of iterations, training is complete. The final model can then be sent to banks to predict the loan risk of new customers. In this scenario, because there is only one data owner, the model performance would be identical to that of a model trained in a typical ML pipeline. However, what happens to the performance when a model is trained on multiple data owners?"
        },
        {
            p: "These code snippets are based on the Asynchronous Federated Learning Tutorial from the OpenMined github repository which trains a model on MNIST handwritten digit recognition data. In this example, the data is split up by digit. Multiple models are trained on subsets of the data and later combined. Let’s compare the performance of Federated Learning to the best performance in research."
        },
        {
            p: "Given the guarantee of 100% privacy, Federated Learning achieves very similar performance to traditional deep learning techniques."
        },
        {
            p: "We see through this process two main benefits. The first is the main goal of federated learning :  privacy. No bank is able to understand what the model architecture is, and we are unable to gain access to any data. The second bonus is enhanced intelligence. Now, banks are able to gain access to more robust models that have been trained on a vast variety of data sources because the model is a culmination of the information from several other financial institutions. The applications of Private AI and federated learning are immense — any use case where personal data is involved, from loans to credit risk, can reap the benefits of these new methodologies."
        },
    ]
}